(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patch-item', {
            parent: 'entity',
            url: '/patch-item?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-item/patch-items.html',
                    controller: 'PatchItemController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchItem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('patch-item-detail', {
            parent: 'entity',
            url: '/patch-item/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-item/patch-item-detail.html',
                    controller: 'PatchItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchItem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PatchItem', function($stateParams, PatchItem) {
                    return PatchItem.get({id : $stateParams.id});
                }]
            }
        })
        .state('patch-item.new', {
            parent: 'patch-item',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-item/patch-item-dialog.html',
                    controller: 'PatchItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                legacyCode: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patch-item', null, { reload: true });
                }, function() {
                    $state.go('patch-item');
                });
            }]
        })
        .state('patch-item.edit', {
            parent: 'patch-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-item/patch-item-dialog.html',
                    controller: 'PatchItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatchItem', function(PatchItem) {
                            return PatchItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patch-item.delete', {
            parent: 'patch-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-item/patch-item-delete-dialog.html',
                    controller: 'PatchItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatchItem', function(PatchItem) {
                            return PatchItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
